import { trimStartEnd } from 'newJs/utils';
import { MAIL } from 'newJs/config';

const { LIST } = MAIL.get('FLAGS');

export default {
    normalizeArray(flagsArray) {
        const normalized = flagsArray.map((item) => trimStartEnd(item).toLowerCase());
        return normalized.filter((item) => LIST.includes(item));
    },
    // flagName may start with the digit 0 or 1
    parseFlag(flagName) {
        return /^\d{1}/.test(flagName)
            ? {
                flag: flagName.slice(1),
                toggle: !!(+flagName.slice(0, 1)) // Convert string to boolean
            }
            : {
                flag: flagName,
                toggle: null
            };
    },
    removeExcluded(excludes, flagList) {
        if (!excludes) return flagList;
        const excludedArray = Array.isArray(excludes) ? excludes : [excludes];

        return flagList.filter(flag => excludedArray.indexOf(flag) === -1);
    }
};

